export default __webpack_public_path__ + "static/media/hht1_ep10_minisitcom_02.e94afa7c.png";